import { AuthLayout } from '@/design-system/layouts'
import { Login } from '../components'

export function LoginPage() {
  return (
    <AuthLayout>
      <Login />
    </AuthLayout>
  )
}
